import { getOneHrCategory, getOneHrCourses } from "api/oneHR";
import CategoryHeader from "components/OneHr/CategoryHeader";
import OneHrCourseItem from "components/OneHr/OneHrCourseItem";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import "./list.css";

const List = () => {
  const { i18n } = useTranslation();
  const match = useRouteMatch();
  const [category, setcategory] = useState();
  const [courses, setcourses] = useState([]);

  const fetchData = async () => {
    const category = await getOneHrCategory(match.params.code);
    const courses = await getOneHrCourses(match.params.code);

    setcategory(category);
    setcourses(courses);

    console.log({ courses });
  };

  useEffect(() => {
    fetchData();
  }, [match, i18n]);

  return (
    <div className="onehr-list">
      <CategoryHeader title={category?.title || "-"} />
      <div className="one-hr-list__courses">
        {courses.map((course) => (
          <OneHrCourseItem
            key={course.oneHrCourseId}
            id={course.oneHrCourseId}
            title={course.title}
            duration={course.duration}
            picture={course.picture}
            href={course.courseUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default List;
